/** zh-CN catalogue `respack` (W3-09; English: src/formats/respack/respack.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'respack',
  locale: 'zh-CN',
  messages: {
    'error.missingInfo': '资源包的顶层没有 info.yml。',
    'error.infoInFolder': 'info.yml 位于文件夹“{folder}”中。Phira 只从顶层读取它：请压缩文件本身，而不是文件夹。',
    'error.infoNotUtf8': 'info.yml 不是有效的 UTF-8 文本。',
    'error.yaml': 'info.yml 不是有效的 YAML（第 {line} 行第 {col} 列）。',
    'error.duplicateKey': 'info.yml 重复设置了同一字段（第 {line} 行）。',
    'error.notMapping': 'info.yml 必须是由“字段: 值”组成的行。',
    'error.missingField': 'info.yml 缺少必需字段“{field}”。',
    'error.fieldType':
      'info.yml 中的字段“{field}”必须是{expected, select, text {文本} wholeNumber {整数} number {数字} bool {true 或 false} pair {由两个整数组成的 [a, b]} other {其他类型的值}}。',
    'error.quotedValue': 'info.yml 中的字段“{field}”不能放在引号中：Phira 会把带引号的值读作文本。',
    'error.outOfRange': 'info.yml 中的字段“{field}”必须在 0 到 {max} 之间。',
    'error.nameEmpty': '资源包名称为空。',
    'error.nameTooLong': '资源包名称长 {bytes} 字节；Phira 最多允许 {max} 字节。',
    'error.descriptionTooLong': '描述长 {bytes} 字节；Phira 最多允许 {max} 字节。',
    'error.hitFxGrid': '打击特效网格 hitFx [{cols}, {rows}] 的帧数必须在 1 到 {max} 之间。',
    'error.missingImage': '资源包中没有 {file}。',
    'error.imageUndecodable': '{file} 不是 Phira 能读取的 PNG、JPEG、GIF、BMP 或 WebP 图片。',
    'error.holdAtlas':
      '{file} 的 Hold 切片（尾部 {tail} px + 头部 {head} px）没有给中段留下空间：图片只有 {height} px 高。',
    'error.soundUndecodable':
      '{file} 不是 Phira 能播放的 Ogg Vorbis、WAV、MP3 或 FLAC 音频。Phira 会按 .ogg、.wav、.mp3 的顺序使用第一个存在的文件。',
    'warning.holdSoundIgnored': '{file} 会被忽略：Hold 开始时 Phira 播放的是 click 打击音。',
    'warning.hitFxUneven':
      'hit_fx.png（{width} x {height} px）无法按 hitFx 网格 [{cols}, {rows}] 均分，帧会被不均匀地切割。',
    'warning.colorAlphaZero': '{field} 的 alpha 为 00。Phira 无法将其与不带 alpha 的颜色区分，会将其绘制为完全不透明。',
    'warning.unusedFiles': '有 {count, plural, other {# 个文件}}未被 Phira 使用（例如“{first}”）。',
  },
};

export default catalog;
